import React from 'react'
import { FormatDate } from '../../../../../../../helpers/datetime'
import PropTypes from "prop-types"

const AddDeleteTable = ({ data }) => {
  return <table className="table table-striped">
    <thead>
      <tr>
        <th>Start</th>
        <th>Drivers</th>
      </tr>
    </thead>
    <tbody>
      {data.map((item) => {
        return <tr key={item.start}>
          <td>{FormatDate(item.start)}</td>
          <td>{item.activeDrivers}</td>
        </tr>
      })}
    </tbody>
  </table>
}

AddDeleteTable.propTypes = {
  data: PropTypes.array
}

export default AddDeleteTable


// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/poolShiftsUpdated/addDeleteTable/index.js